import RaaChannelKey from './RaaChannelKey';

class Alert {
  constructor(
    id,
    description,
    triggeredAlertEvent,
    timezone,
    lastReading,
    triggerCondition,
    clearCondition,
    temperatureScale,
    alertActionList,
    isDeviceAssignmentSuspended,
    isAlertDeactivated,
    isAcknowledged,
    isFavorite,
    channelKey,
    customTemplate,
    customUnits,
    additionalChannelKeys,
    tagIds = [],
  ) {
    this.id = id;
    this.description = description;
    this.triggeredAlertEvent = triggeredAlertEvent;
    this.timezone = timezone;
    this.lastReading = lastReading;
    this.triggerCondition = triggerCondition;
    this.clearCondition = clearCondition;
    this.temperatureScale = temperatureScale;
    this.alertActionList = alertActionList;
    this.isDeviceAssignmentSuspended = isDeviceAssignmentSuspended;
    this.isAlertDeactivated = isAlertDeactivated;
    this.isAcknowledged = isAcknowledged;
    this.isFavorite = isFavorite;
    this.channelKey = new RaaChannelKey(channelKey);
    this.customTemplate = customTemplate;
    this.customUnits = customUnits;
    this.additionalChannelKeys = additionalChannelKeys;
    this.tagIds = tagIds;
    this.tags = [];
  }
}
export default Alert;
